import { Injectable } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { pairwise } from 'rxjs/operators';

@Injectable()
export class LastRouterService {
  public lastRoute = "";

  constructor(router: Router) {
    router.events
      .pipe(pairwise(),
    ).subscribe((e: any) => {
      if (e[0] instanceof NavigationEnd && e[1] instanceof NavigationStart) {
        this.lastRoute = (e[0] as NavigationEnd).urlAfterRedirects;
      }
    });
  }
}


// WEBPACK FOOTER //
// ./client/app/last-route.service.ts